

const NotFoundPage = () => {
  return (
    <div className="not-found-page">
     <div className="central">
      <h1>404 - A página solicitada não pôde ser encontrada</h1>
     </div>
    </div>
  );
}

export default NotFoundPage;
